
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loan-refinance",
      function () {
        return require("private-next-pages/loan-refinance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loan-refinance"])
      });
    }
  